import { render, staticRenderFns } from "./MySpacePersonalTasksWidget.vue?vue&type=template&id=105cbc68&"
import script from "./MySpacePersonalTasksWidget.vue?vue&type=script&lang=js&"
export * from "./MySpacePersonalTasksWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports